export default {"src":"/_next/static/media/truck.c2780945.svg","height":22,"width":26,"blurWidth":0,"blurHeight":0};